export default __webpack_public_path__ + "static/media/flag-iceland.d2edff6d.svg";